var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('client-only',[_c('div',[_c('nuxt',{staticClass:"h-screen w-screen"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }